export const FlagEntityTypeEnum = {
  Chat: 'CHAT',
  Post: 'POST',
  Comment: 'COMMENT',
  Group: 'GROUP'
} as const;

export type FlagEntityTypeEnum =
  (typeof FlagEntityTypeEnum)[keyof typeof FlagEntityTypeEnum];
